import React from 'react';
import { observer } from 'mobx-react';
import { Paragraph, Text } from 'components';
import { Link } from 'core/routing';
import { clientStore } from 'apps/client/app';
import colors from 'styles/themes/wikifactory/styles/colors';
import type { SpaceModel } from 'apps/space/app';
import { Size, Variant } from './types';
import { mapSize } from './mapSize';

export interface SpaceLinkProps {
  space: SpaceModel;
  mt?: number;
  label?: string;
  underlined?: boolean;
  size?: Size;
  variant?: Variant;
}

export const SpaceLink = observer(function SpaceLink({
  label,
  space,
  underlined = true,
  variant = 'secondary',
  size = 'small',
  mt = 1,
}: SpaceLinkProps) {
  const { signedInProfile } = clientStore;
  const spaceTypeLowerCased = space?.spaceType?.toLowerCase();

  let sharedByText = '';

  if (space.path === signedInProfile?.username) {
    sharedByText = 'you';
  } else if (space.spaceType === 'PROFILE') {
    sharedByText = `@${space.content.slug}`;
  } else if (space.spaceType === 'INITIATIVE') {
    sharedByText = `${space.content.title}`;
  }

  let linkStyle = {};

  if (underlined) linkStyle = { textDecoration: 'underline' };
  if (variant === 'secondary') {
    linkStyle = { ...linkStyle, color: colors.wfGrey600 };
  }
  if (variant === 'primary') {
    linkStyle = { ...linkStyle, color: colors.primary };
  }

  return (
    <Paragraph size={mapSize(size)} display='inline-flex' mt={mt}>
      {label && (
        <Text mr={1} size='inherit'>
          {label}
        </Text>
      )}
      <Link
        name={spaceTypeLowerCased}
        params={{
          [spaceTypeLowerCased]: space.path,
        }}
        id='super-link'
        style={linkStyle}
      >
        {sharedByText}
      </Link>
    </Paragraph>
  );
});
